module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contentsPage",
    attrs: {
      "id": "d7e155"
    }
  }, [_c('h3', {
    staticClass: "toc",
    staticStyle: {
      "margin-left": "-.4em"
    }
  }, [_c('i', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('a', {
    attrs: {
      "href": "#/_9781440506963_epub_c1#c1"
    }
  }, [_vm._v("Foreword")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('a', {
    attrs: {
      "href": "#/_9781440506963_epub_c2#c2"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/_9781440506963_epub_c3#c3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Appendix A:")]), _vm._v(" Recommended Resources")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/_9781440506963_epub_c4#c4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Appendix B:")]), _vm._v(" The 101 Secrets Every Woman Should Know")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/_9781440506963_epub_c6#c6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")]), _vm._v(" "), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46e72eae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_9781440506963_epub_toc.vue
// module id = 75
// module chunks = 0